import {
  TargetType,
  Transfer,
  TransferStatus,
  VolumeColorTransfer,
  VolumeColorTransferNormalized,
} from "../interfaces/HairTransfer";
import { HairStyle } from "../interfaces/hairType";

export const normalizeTransfer = (
  transfer: VolumeColorTransfer
): VolumeColorTransferNormalized[] => {
  const urls = transfer.urls;
  if (!urls?.length) return [];

  const normalized: VolumeColorTransferNormalized[] = urls.map((url) => {
    if (url.image_url === "") {
      return {
        volume: "",
        color: "",
        image_url: url.image_url,
        state: transfer.state,
      };
    }
    const [volume, color] = url.image_url
      ?.split("?")[0]
      .split("/swaps/")[1]
      .split("/")[1]
      .replace(".jpeg", "")
      .replace(".png", "")
      .split("_");

    return {
      volume,
      color,
      image_url: url.image_url,
      state: transfer.state,
    };
  });

  return normalized;
};

export const isCompletedSuccesfully = (
  transfer: Transfer | undefined,
  targetType: TargetType
) =>
  transfer?.status === TransferStatus.Success &&
  transfer.state === "finished" &&
  transfer.target_type === targetType;

export const updateHairStyleState = (
  hairStyles: HairStyle[],
  transfer: Transfer
) => {
  const newHairStyles: HairStyle[] = [];
  hairStyles?.map((style: HairStyle) => {
    const newStyle = {
      ...style,
      loading: transfer?.state === "processing" || transfer?.state === "queued",
      failed: transfer?.status === TransferStatus.Failed,
    };
    newHairStyles.push(newStyle);
  });
  return newHairStyles;
};

export const getTransferAndHairStyles = (
  styles: HairStyle[],
  transfers: Transfer[],
  targetType: TargetType,
  transferSelected: Transfer | undefined
) => {
  const newHairStyles: HairStyle[] = [];
  let newTransferSelected: Transfer | undefined = transferSelected;
  styles?.map((style: HairStyle) => {
    const transfer = transfers.find(
      (transfer: Transfer) => transfer.hairstyleId === style.genomeId
    );
    const newStyle = {
      ...style,
      loading: transfer?.state === "processing" || transfer?.state === "queued",
      failed: transfer?.status === TransferStatus.Failed,
    };
    newHairStyles.push(newStyle);

    if (isCompletedSuccesfully(transfer, targetType) && !transferSelected) {
      newTransferSelected = transfer;
    }
  });
  return { newTransferSelected, newHairStyles };
};
